import React from 'react'
import Checkbox from 'components/Checkbox'
import { WEEK_DAYS, TWeekDay, IWeeklySchedule } from 'pages/Planning/types'

interface WeeklyScheduleProps {
  weeklySchedule: IWeeklySchedule
  onDayToggle: (dayKey: TWeekDay, isSelected: boolean) => void
  isDarkMode?: boolean
}

const WeeklySchedule: React.FC<WeeklyScheduleProps> = ({ weeklySchedule, onDayToggle }) => {
  return (
    <div className="weekly-schedule">
      <h3 className="weekly-schedule-title">Configure sua rotina semanal de estudos:</h3>
      <p className="weekly-schedule-description">
        Distribua suas sessões de estudo ao longo da semana para manter um ritmo consistente.
      </p>

      <div className="weekly-schedule-options">
        {WEEK_DAYS.map((day) => {
          const dayData = weeklySchedule[day.key]
          const isSelected = dayData?.isSelected || false

          return (
            <div key={day.key} className={`weekly-schedule-option ${isSelected ? 'selected' : ''}`}>
              <div>
                <Checkbox
                  value={isSelected}
                  className="checkbox"
                  onChange={(checked) => onDayToggle(day.key, checked as boolean)}
                >
                  {day.label}
                </Checkbox>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default WeeklySchedule
